import {ApolloLink} from '@apollo/client';
import type {Fetch} from '@sail/data';
import {createHttpLink} from '../../shared/graphql/links/createTerminatingLink';

function createErrorDecoratorLink() {
  return new ApolloLink((operation, forward) => {
    return forward(operation)?.map(function errorDecoratorLinkResponse(res) {
      const {response} = operation.getContext();

      res.errors?.forEach((error) => {
        // @ts-expect-error Allow re-defining extensions in case it doesn't exist.
        error.extensions = error.extensions || {};

        error.extensions.error = error.extensions.error || {};
        error.extensions.error.source = '<unknown>';
        error.extensions.error.status = response.status;

        Object.defineProperty(error.extensions, 'unstable_requestId', {
          value: response.headers.get('Request-Id'),
          writable: true,
          configurable: true,
        });
      });

      return res;
    });
  });
}

export default function createHttpLinkWrapper(
  endpoint: string,
  fetch: Fetch,
  url: string,
) {
  return createErrorDecoratorLink().concat(
    createHttpLink(endpoint, fetch, url),
  );
}
